var map = {
	"./es.json": [
		"../../../../../src/assets/i18n/es.json",
		"es.json"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/assets/i18n lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/assets/i18n lazy ^\.\/.*\.json$
// module id = ../../../../../src/assets/i18n lazy recursive ^\.\/.*\.json$
// module chunks = main